import { v4 as uuidv4 } from 'uuid';

import { UUID } from 'backend-client-web';

export const nullUuid = '00000000-0000-0000-0000-000000000000';

export function newUuid(): UUID {
  return uuidv4();
}

export function uuidEqual(id1: UUID, id2: UUID): boolean {
  return id1.toLowerCase() === id2.toLowerCase();
}

export type { UUID };
